import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const FooterContainer = styled.footer`
  background: #2c3e50;
  color: white;
  margin-top: auto;
`;

const FooterMain = styled.div`
  padding: 3rem 0;

  .container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
  }

  .footer-section {
    h3 {
      color: #dc2626;
      margin-bottom: 1.5rem;
      font-size: 1.2rem;
    }

    p {
      line-height: 1.8;
      margin-bottom: 1rem;
    }

    .footer-logo {
      width: 180px;
      height: 60px;
      margin-bottom: 1rem;
    }

    ul {
      list-style: none;

      li {
        margin-bottom: 0.5rem;

        a {
          color: #ecf0f1;
          transition: color 0.3s ease;
          display: flex;
          align-items: center;

          &:hover {
            color: #dc2626;
          }

          &:before {
            content: "→";
            margin-right: 0.5rem;
            color: #dc2626;
          }
        }
      }
    }

    .contact-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 1rem;

      img {
        width: 20px;
        height: 20px;
        margin-right: 0.5rem;
        margin-top: 0.2rem;
      }

      .contact-content {
        flex: 1;

        strong {
          display: block;
          margin-bottom: 0.25rem;
        }

        a {
          color: #ecf0f1;

          &:hover {
            color: #dc2626;
          }
        }
      }
    }
  }
`;

const FooterBottom = styled.div`
  background: #1a252f;
  padding: 1.5rem 0;
  border-top: 1px solid #34495e;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .copyright {
    color: #bdc3c7;
    font-size: 0.9rem;
  }

  .design-credit {
    color: #bdc3c7;
    font-size: 0.9rem;

    a {
      color: #dc2626;

      &:hover {
        color: #e74c3c;
      }
    }
  }

  @media (max-width: 768px) {
    .container {
      flex-direction: column;
      text-align: center;
    }
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterMain>
        <div className="container">
          <div className="footer-section">
            <h3>About Ausgrip Tyres</h3>
            <img
              src="/images/logo.png"
              alt="Ausgrip Tyres Logo"
              className="footer-logo"
            />
            <p>
              Our competitive advantage is not being tied to any one particular brand. Supporting major tyre brands ensuring constant supply &
              customer choice, with several alternatives achieving the best possible value for any application.
            </p>
            <Link
              to="/about"
              style={{ color: "#dc2626" }}>
              Read more...
            </Link>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/get-quote">Get a Quote</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Our Services</h3>
            <ul>
              <li>
                <Link to="/services#mobile-fitting">Mobile Tyre Fitting</Link>
              </li>
              {/* Breakdown cover removed per request */}
              <li>
                <Link to="/services#new-tyres">Reliable New Tyres</Link>
              </li>
              <li>
                <Link to="/services#puncture-repair">Tyre Puncture Repair</Link>
              </li>
              <li>
                <Link to="/services#tyre-rotation">Tyre Rotation</Link>
              </li>
              <li>
                <Link to="/trailer-repair">Trailer tyre repair services</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Get in Touch</h3>

            <div className="contact-item">
              <img
                src="/images/locat_icon.png"
                alt="Location"
              />
              <div className="contact-content">
                <strong>Address:</strong>
                Unit 6/1717 Ipswich Road, Rocklea QLD 4106
              </div>
            </div>

            <div className="contact-item">
              <img
                src="/images/phnee_icon.png"
                alt="Phone"
              />
              <div className="contact-content">
                <strong>Phone:</strong>
                <a href="tel:0413960242">0413960242</a>
              </div>
            </div>

            <div className="contact-item">
              <img
                src="/images/e-mail_icon.png"
                alt="Email"
              />
              <div className="contact-content">
                <strong>E-mail:</strong>
                <a href="mailto:contact@ausgriptyres.com.au">contact@ausgriptyres.com.au</a>
              </div>
            </div>
          </div>
        </div>
      </FooterMain>

      <FooterBottom>
        <div className="container">
          <div className="copyright">
            Copyright © {currentYear} <span style={{ color: "#dc2626" }}>Ausgrip Tyres</span>. All Rights Reserved.
          </div>
        </div>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
